export default __webpack_public_path__ + "static/media/step-one-1.29b86d96.svg";